module.exports = __webpack_public_path__ + "media/images/home-tablet-ebf17c63cf0253e3e304edf91ee59694.jpg";